import Admin from '@/models/bread/Admin/save'

export default {
  key:'Save',
  name:{
    singular:'Save',
    plural:'Saves',
  },
  parents:[
    'Student',
    'Game',
  ],
  Admin:Admin,
  Moderator:false,
  Teacher:false,
}